
import store from '../redux/store'
import {axios} from '../utils'
import { useSelector } from 'react-redux';


export const callBBCard = async (payload)=>{
    try{
        let { data } = await axios.post(`${process.env.REACT_APP_CHATCON_URL}/baseball-create-crypt-request`,{
            contextParameters:payload
        })

        
        if(data) {
            return data;
        } else {
            return null;
        }
    }   catch (e){
        return null;
    }
}

export const voiceBBCard = async (payload)=>{
    try{
        let { data } = await axios.post(`${process.env.REACT_APP_CHATCON_URL}/baseball-voice-create-crypt-request`,{
            contextParameters:payload
        })

        
        if(data) {
            return data.bbcId;
        } else {
            return null;
        }
    }   catch (e){
        return null;
    }
}


export const endVoiceBBCard = async (payload) => {
    try {
        const { data } = await axios.post(
            `${process.env.REACT_APP_CHATCON_URL}/baseball-voice-end-crypt-request`,
            payload,
            {
                headers: {
                    "X-API-KEY": "AIzaSyCjycAkPA1Tlyrv-6nSuyql0WnnB5W84tA",
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                },
            }
        );

        if (data) {
            return data;
        } else {
            return null;
        }
    } catch (e) {
        console.error("Error in endVoiceBBCard:", e);
        return null;
    }
};